import { FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { TabForm } from '../forms/tab-form';
import { User } from '../user';

export class UserForm {
    Username = new FormControl();
    Enabled = new FormControl();
    Status = new FormControl();
    Email = new FormControl();
    Emailverified = new FormControl();
    Groups = new FormControl();
    CreatedDate = new FormControl();
    LastModifiedDate = new FormControl();
    GroupsUpdated = new FormControl();
    Tabs: FormArray = new FormArray([]);

    constructor(data: User, private fb: FormBuilder) {

        this.Username.setValue(data.Username);
        this.Enabled.setValue(data.Enabled);
        this.Status.setValue(data.Status);
        this.Email.setValue(data.Email);
        this.Emailverified.setValue(data.Emailverified);
        this.Emailverified.disable();
        this.Groups.setValue(data.Groups);
        this.CreatedDate.setValue(data.CreatedDate);
        this.LastModifiedDate.setValue(data.LastModifiedDate);
        this.GroupsUpdated.setValue([]);

        data.Tabs.forEach(n => {
            this.Tabs.push(this.fb.group(new TabForm(n, this.fb)));
        });
    }
}
